import {makeStyles} from "@material-ui/core";
import {blue} from "@material-ui/core/colors";

export default makeStyles((theme) => ({
  signatureCanvas: {
    width: "100%",
    height: 150,
    border: `1px dashed ${blue[400]}`,
    borderRadius: theme.shape.borderRadius,
  },
  clearSignatureButton: {
    display: "block",
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
    marginInline: "auto",
    color: theme.palette.primary.main,
    fontWeight: 700,
    textAlign: "center",
  },
}));
